<template>
  <div class='platform-contracts mt-3 p-3 mb-5'>
    <ModalConfirmAction
      variant='danger'
      refModal='deleteConfirmation'
      idModal='deleteConfirmation'
      :loading='loading'
      :description='descriptionDelete'
      :title='titleDelete'
      @confirmed='deleteReportFile'
    />

    <b-modal
      ref='createReportFile'
      id='createReportFile'
      scrollable
      size='lg'
      title='Cadastrar arquivo para relatório'
      header-bg-variant='info'
      header-text-variant='light'
    >
      <section class='modal-font-family'>
        <section>
          <label for='methodology'><strong>Metodologia</strong></label>
          <b-form-select
            id='methodology'
            v-model='filesDescriptionMethodology.methodology'
            :options='methodologies'
            style='height: 50px'
            value-field='key'
            text-field='value'
          >
            <template #first>
              <b-form-select-option :value='null' disabled>Selecione a metodologia</b-form-select-option>
            </template>
          </b-form-select>
        </section>

        <section
          class='mt-3'
          v-if="filesDescriptionMethodology && filesDescriptionMethodology.methodology && filesDescriptionMethodology.methodology === 'HFW'"
        >
          <label for='methodology'><strong>Memorial de cálculo</strong></label>
          <b-form-select
            id='methodology'
            v-model='filesDescriptionMethodology.calculationMemorial'
            :options='calculationMemorials'
            style='height: 50px'
            value-field='key'
            text-field='value'
          >
            <template #first>
              <b-form-select-option :value='null' disabled>Selecione o memorial de cálculo</b-form-select-option>
            </template>
          </b-form-select>
        </section>

        <section class='mt-3 '>
          <section class='w-100'>
            <label for='filesAdhesionContractUrl'><strong>Arquivo para descrição da metodologia</strong></label>
            <b-form-file
              name='file'
              id='file'
              v-model='file'
              placeholder='Selecione o arquivo para descrição da metodologia'
              accept='.pdf'
              browse-text='Selecione o arquivo'
            >
            </b-form-file>
          </section>
          <section class='w-100 mt-2' v-if='filesDescriptionMethodology && filesDescriptionMethodology.url'>
            <a
              class=' mt-3 mt-5'
              :href='filesDescriptionMethodology.url'
              target='_blank'
            >
              Ver arquivo anexado
            </a>
          </section>
        </section>
      </section>

      <section class='mt-3'>
        <b-alert show variant='danger' :class='{ hidden: !hasErrors() }'>
          {{ error }}<br />
        </b-alert>
      </section>
      <template #modal-footer='{ ok, cancel, hide }'>
        <section class='d-flex w-100 modal-font-family'>
          <b-button
            variant='danger'
            class='w-50 mr-2'
            @click='cancel()'
          >
            Cancelar
          </b-button>

          <b-overlay
            :show='loading'
            rounded
            opacity='0.6'
            spinner-small
            spinner-variant='primary'
            class='d-inline-block w-50'
          >
            <b-button
              @click='submit()'
              variant='success'
              class='w-100'
            >
              {{ filesDescriptionMethodology && filesDescriptionMethodology._id ? 'Atualizar' : 'Cadastrar' }}
            </b-button>
          </b-overlay>
        </section>
      </template>
    </b-modal>

    <b-overlay
      :show='loadingGet'
      rounded
      opacity='0.6'
      ariant='info'
      spinner-variant='info'
      class='d-inline-block w-100'
    >
      <h1>
        Gerenciar Arquivos de relatório
      </h1>

      <hr class='mt-4 mb-1' />
      <section class='d-flex justify-content-end mt-3'>
        <b-button
          variant='primary'
          class=''
          @click='showModalCreateReportFile()'
        >
          Cadastrar arquivo para relatório
        </b-button>
      </section>

      <section class='mt-4 '>
        <b-list-group>
          <b-list-group-item
            v-for='(filesDescriptionMethodology, index) in listFilesDescriptionMethodology'
            :key='filesDescriptionMethodology._id'
            class=''>
            <section class='d-flex justify-content-between align-items-start'>
              <section>
                <span><strong>Metodologia: </strong>{{ methodologies.find(x => x.key == filesDescriptionMethodology.methodology).value
                  }}</span><br />

                <span v-if='filesDescriptionMethodology.calculationMemorial'>
                  <strong>Memorial de cálculo: </strong>
                  {{ calculationMemorials.find(x => x.key == filesDescriptionMethodology.calculationMemorial).value }} <br />
                </span>
                <span><strong>Arquivo da descrição da metodologia: </strong><a
                  class='  mt-3 '
                  :href='filesDescriptionMethodology.url'
                  target='_blank'
                >
                  Ver arquivo anexado
                </a> </span>
              </section>

              <section>
                <b-icon
                  class='mr-3 cursor-pointer'
                  font-scale='1.6'
                  icon='trash'
                  variant='danger'
                  @click='showModalDeleteConfirmation(filesDescriptionMethodology)'
                >
                </b-icon>
                <b-icon
                  class='cursor-pointer'
                  font-scale='1.6'
                  icon='pencil-square'
                  variant='success'
                  @click='showModalEditReportFile(filesDescriptionMethodology._id)'
                >
                </b-icon>
              </section>
            </section>
          </b-list-group-item>
        </b-list-group>
      </section>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { upload } from '@/utils/upload'
import { format } from 'date-fns'
import ModalConfirmAction from '@/components/ModalConfirmAction.vue'

export default {
  name: 'ManageFilesDescriptionMethodology',
  components: { ModalConfirmAction },
  data() {
    return {
      listFilesDescriptionMethodology: [],
      calculationMemorial: null,
      methodology: null,
      filesDescriptionMethodology: {
        _id: null,
        url: null,
        calculationMemorial: null,
        methodology: null
      },
      file: null,
      methodologies: [
        {
          key: 'HFW',
          value: 'HO Fácil Web'
        },
        {
          key: 'CB',
          value: 'Control Banding'
        },
        {
          key: 'VHR',
          value: 'VHR'
        }
      ],
      loading: false,
      loadingGet: false,
      descriptionDelete: '',
      titleDelete: '',
      reportFileCurrent: null
    }
  },
  created() {
    const breadcrumb = {
      tab: '',
      page: 'Gerenciar Arquivos de relatório',
      subPage: {
        name: 'Gerenciar Arquivos de relatório',
        active: true
      },
      tabs: []
    }
    this.setBreadcrumb(breadcrumb)
  },
  async mounted() {
    try {
      await this.getReportFiles()
    } catch (e) {

    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    error() {
      return this.$store.getters['access/error']
    },
    ...mapGetters('filesDescriptionMethodology', {
      calculationMemorials: 'getCalculationMemorials',
    }),
  },
  methods: {
    format,
    ...mapActions('filesDescriptionMethodology', {
      handleCreate: 'handleCreate',
      handleUpdade: 'handleUpdade',
      handleGet: 'handleGet',
      handleGetAll: 'handleGetAll',
      handleDelete: 'handleDelete'
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    ...mapActions('user', {
      handleUpdatePrivacyPolicy: 'handleUpdatePrivacyPolicy',
      handleUpdateTermsOfUse: 'handleUpdateTermsOfUse'
    }),

    async getReportFiles() {
      try {
        this.loadingGet = true
        this.listFilesDescriptionMethodology = await this.handleGetAll({
          calculationMemorial: this.calculationMemorial,
          methodology: this.methodology
        })
        this.loadingGet = false
      } catch (e) {

      }
    },

    reset() {
      this.file = null
      this.filesDescriptionMethodology = {
        _id: null,
        url: null,
        calculationMemorial: null,
        methodology: null
      }
    },

    async isValid() {
      if (!this.filesDescriptionMethodology.methodology) {
        await this.$store.dispatch('access/updateError', `Selecione a Metodologia`)
        return false
      } else if (!this.filesDescriptionMethodology.calculationMemorial && this.filesDescriptionMethodology.methodology == 'HFW')  {
        await this.$store.dispatch('access/updateError', `Selecione o memorial de cálculo`)
        return false
      } else if (!this.filesDescriptionMethodology.url && !this.file) {
        await this.$store.dispatch('access/updateError', `Selecione o Arquivo para descrição da metodologia`)
        return false
      }
      return true
    },

    hasErrors() {
      return !!this.error
    },

    async submit() {
      try {
        await this.$store.dispatch('access/updateError', ``)
        let response = {}
        if (!await this.isValid()) {
          return
        }
        this.loading = true
        if(this.filesDescriptionMethodology.methodology != 'HFW') {
          this.filesDescriptionMethodology.calculationMemorial = null
        }
        if (this.filesDescriptionMethodology && this.filesDescriptionMethodology._id) {
          if (this.file) {
            this.filesDescriptionMethodology.url = await upload(this.file)
          }

          response = await this.handleUpdade(this.filesDescriptionMethodology)
        } else {
          this.filesDescriptionMethodology.url = await upload(this.file)
          response = await this.handleCreate(this.filesDescriptionMethodology)
        }
        const { data, status } = response
        let message = data.message
        let variant = 'danger'
        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.loading = false
        this.reset()
        await this.getReportFiles()
        await this.closeModalCreateReportFile()
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('Não foi possível executar essa ação, verifique os dados e tente novamente.', {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.loading = false
      }
    },

    showModalDeleteConfirmation(filesDescriptionMethodology) {
      try {
        this.reportFileCurrent = filesDescriptionMethodology
        this.$bvModal.show('deleteConfirmation')
        this.titleDelete = `Excluir arquivo`
        this.descriptionDelete = `Deseja realmente excluir o arquivo da metodologia?`
      } catch (e) {

      }
    },

    async showModalCreateReportFile() {
      try {
        this.reset()
        await this.$store.dispatch('access/updateError', ``)
        this.$bvModal.show('createReportFile')
      } catch (e) {

      }
    },

    async closeModalCreateReportFile() {
      try {
        await this.$store.dispatch('access/updateError', ``)
        this.$bvModal.hide('createReportFile')
      } catch (e) {

      }
    },

    async showModalEditReportFile(_id) {
      try {
        this.loadingGet = true
        this.filesDescriptionMethodology = await this.handleGet(_id)
        await this.$store.dispatch('access/updateError', ``)
        this.$bvModal.show('createReportFile')
        this.loadingGet = false
      } catch (e) {

      }
    },

    async deleteReportFile() {
      try {
        this.loading = true
        const { data, status } = await this.handleDelete(this.reportFileCurrent._id)
        let message = data.message
        let variant = 'danger'
        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.$bvModal.hide('deleteConfirmation')
        await this.getReportFiles()
        this.loading = false
      } catch (e) {
        console.error('e')
        console.error(e)
        console.error('e')
        this.$bvToast.toast('Não foi possível executar essa ação, verifique os dados e tente novamente.', {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.$bvModal.hide('deleteConfirmation')
        this.loadingReset = false
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.platform-contracts {
  background: #FFFFFF !important;
  border: 1px solid #C0C0C0;

  h1 {
    font-size: 20px;
    font-weight: 700;
    line-height: 24.38px;
    text-align: left;
    color: #262626;
  }

  hr {
    background: #C0C0C0;
  }

  .label-form {
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    color: var(--navy-blue);
    text-decoration: underline;
  }

}

.file-uploaded {
  width: fit-content;

  display: flex;
  align-items: center;
  justify-content: end;
  gap: 8px;
  float: right;
  margin-bottom: 20px;
  color: var(--navy-blue);
  border: 1px solid var(--navy-blue);

  padding: 6px 12px;

  border-radius: 4px;

  transition: all 0.2s ease-in-out;

  text-decoration: none;

  cursor: pointer;
}
</style>
